import type { FillMark } from '@wtfalch/design';

/**
 * Agora's mark: a person standing in an arch.
 *
 * An agora is where people meet, so the mark is a doorway with someone in it.
 * The app icon draws it as a stroked arch and a coloured dot on a tile
 * (`public/icons/`). A `Mark` is one `d` in one colour, so here the arch is its
 * filled outline -- stroke 3.4 with round feet -- and the dot is two half-arcs,
 * both under `nonzero`. They never overlap, so the dot stays solid.
 */
export const ARCH: FillMark = {
  view: '0 0 24 24',
  d: 'M3.9 18.2V12.6a8.1 8.1 0 0 1 16.2 0V18.2a1.7 1.7 0 0 1 -3.4 0V12.6a4.7 4.7 0 0 0 -9.4 0V18.2a1.7 1.7 0 0 1 -3.4 0ZM9.4 15.1a2.6 2.6 0 1 0 5.2 0a2.6 2.6 0 1 0 -5.2 0',
  fill: 'nonzero',
};
